import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import {
    DataManagementTreeComponent,
    DataManagementTreeFlatNode,
} from '@em4cloud/data-management-tree';
import { Translation, TranslocoService } from '@ngneat/transloco';
import { BpmUniversalDataObject } from 'app/api';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import { SaveButtonService } from 'app/core/save-button/save-button.service';
import { DataTableSimpleDto } from 'app/data-api';
import { DataManagementMenuService } from 'app/modules/data-module/data-management/data-management-menu.service';
import { DicitonaryServiceImpl } from 'app/modules/data-module/dictionary/dicitonary.service';
import { SysService } from 'app/modules/org-sys-area/services/sys.service';
import { OrgNavigationService } from 'app/services/org-nav.service';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'select-table-dialog',
    imports: [DataManagementTreeComponent],
    templateUrl: './select-table-dialog.component.html',
    styleUrl: './select-table-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTableDialogComponent extends DialogBuilderComponent<any> {
    dataManagementData: Signal<DataTableSimpleDto[]>;
    mdoSystems: Signal<BpmUniversalDataObject[]>;
    isSelectionDialog = true;

    constructor(
        private _orgNav: OrgNavigationService,
        private sysService: SysService,
        private _translocoService: TranslocoService,
        private _saveButtonService: SaveButtonService,
        private dictionaryService: DicitonaryServiceImpl,
        private _dataManagementMenuService: DataManagementMenuService
    ) {
        super();

        this.dictionaryService.getDataTableSimpleDtos().toPromise();

        this.mdoSystems = computed(() => {
            const a = this.sysService.state();
            return a;
        });
        this.dataManagementData = computed(() => {
            const state = this.dictionaryService.state();

            return state;
        });

        this.translocoContent = toSignal(this._translocoService.selectTranslation('data'));
    }

    translocoContent: Signal<Translation>;

    selectedNodeId = computed(() => this.dictionaryService.selectedDataTable()?.tableName, {
        equal: (a, b) => a === b,
    });

    canChangeTreeNodeSelection(node: DataManagementTreeFlatNode): Observable<boolean> {
        let canChange = new Subject<boolean>();

        if (!this.isSelectionDialog) {
            const finalUrl = this._dataManagementMenuService.buildNodeRelativeLink(node);
            // set id of the selected node in the url
            this._orgNav.navigateByUrl(finalUrl);

            let continueWithoutSaving = this._saveButtonService.continueWithoutSaving
                .pipe(takeUntilDestroyed(this._destroyRef))
                .subscribe({
                    next: value => {
                        canChange.next(value);
                        continueWithoutSaving.unsubscribe();
                    },
                });
        } else {
            // setTimeout so that it is emitted after the observable is returned
            setTimeout(() => {
                canChange.next(true);
            });
        }
        return canChange.asObservable();
    }

    treeNodeSelected(node: DataManagementTreeFlatNode): void {
        this.componentData.selectedTable.set(node.title);
    }
}
